import { render } from "./AuthorTable.vue?vue&type=template&id=b2a4d9fa"
import script from "./AuthorTable.vue?vue&type=script&lang=ts"
export * from "./AuthorTable.vue?vue&type=script&lang=ts"
script.render = render

export default script